import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowLeftOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileArrowLeftOut"><Path d="M7.81055 16L5.56055 18.25H12V19.75H5.56055L7.81055 22L6.75 23.0605L2.68945 19L6.75 14.9395L7.81055 16Z" fill="currentColor"/><Path d="M12 10H20V21.25C20 21.6642 19.6642 22 19.25 22H13.5V16.75H9.18164L9.93164 16L6.75 12.8184L4 15.5684V2.75C4 2.33579 4.33579 2 4.75 2H12V10Z" fill="currentColor"/><Path d="M19.5605 8.5H13.5V2.43945L19.5605 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileArrowLeftOut;
